import React, { useState, useEffect } from 'react';
import { generateXraySpineReport } from '../../utils/xrayspinecervical';
import { API_BASE_URL } from '../Api/apiconnector';

export default function XRaySpineForm({ onClose, currentUser, generateReport, onSubmit }) {
  const [formData, setFormData] = useState({
    // Patient Info
    NameTextFR10: '',
    IDTextFR10: '',
    AgeTextFR10: '',
    TestDateTextFR10: '',
    ReportDateTextFR10: '',
    GenderTextFR10: '',
    ReferralDrTextFR10: '',
    ReporttimeTextFR10: '',
    
    // Spine View
    SpineView: '',
    SpineViewAP: false,
    SpineViewLateral: false,
    SpineViewFlexion: false,
    SpineViewExtension: false,
    
    // Main conditions
    NormalSpine: false,
    CervicalDegenerative: false,
    CervicalFracture: false,
    CerivicalOsteopenia: false,
    CervicalFacetJointDislocationFrature: false,
    CervicalCollapse: false,
    
    // Degenerative details
    cervicalLordosis: false,
    cervicalLordosisType: '',
    CervicalOsteophytes: false,
    CervicalOsteophytesC1: false,
    CervicalOsteophytesC2: false,
    CervicalOsteophytesC3: false,
    CervicalOsteophytesC4: false,
    CervicalOsteophytesC5: false,
    CervicalOsteophytesC6: false,
    CervicalOsteophytesC7: false,
    
    CervicalEndplateSclerosis: false,
    CervicalEndplateSclerosisC1: false,
    CervicalEndplateSclerosisC2: false,
    CervicalEndplateSclerosisC3: false,
    CervicalEndplateSclerosisC4: false,
    CervicalEndplateSclerosisC5: false,
    CervicalEndplateSclerosisC6: false,
    CervicalEndplateSclerosisC7: false,
    
    // NEW: Vacuum Phenomenon
    CervicalVacuumPhenomenon: false,
    CervicalVacuumPhenomenonC1: false,
    CervicalVacuumPhenomenonC2: false,
    CervicalVacuumPhenomenonC3: false,
    CervicalVacuumPhenomenonC4: false,
    CervicalVacuumPhenomenonC5: false,
    CervicalVacuumPhenomenonC6: false,
    CervicalVacuumPhenomenonC7: false,
    
    // NEW: Schmorl's Nodes
    CervicalSchmorlsNode: false,
    CervicalSchmorlsNodeC1: false,
    CervicalSchmorlsNodeC2: false,
    CervicalSchmorlsNodeC3: false,
    CervicalSchmorlsNodeC4: false,
    CervicalSchmorlsNodeC5: false,
    CervicalSchmorlsNodeC6: false,
    CervicalSchmorlsNodeC7: false,
    
    // NEW: Reduced Intervertebral Disc Space
    CervicalInterVertebralDiscSpace: false,
    CervicalInterVertebralDiscSpaceC1C2: false,
    CervicalInterVertebralDiscSpaceC2C3: false,
    CervicalInterVertebralDiscSpaceC3C4: false,
    CervicalInterVertebralDiscSpaceC4C5: false,
    CervicalInterVertebralDiscSpaceC5C6: false,
    CervicalInterVertebralDiscSpaceC6C7: false,
    
    // Fracture details
    CervicalCompressionFracture: false,
    CervicalRetropulsion1: false,
    CervicalCompressionFractureC1: false,
    CervicalCompressionFractureC2: false,
    CervicalCompressionFractureC3: false,
    CervicalCompressionFractureC4: false,
    CervicalCompressionFractureC5: false,
    CervicalCompressionFractureC6: false,
    CervicalCompressionFractureC7: false,
    CervicalCompressionFractureT1: false,
    CervicalCompressionFractureT2: false,
    
    // NEW: Burst Fracture
    CervicalBurstFracture: false,
    CervicalRetropulsion2: false,
    CervicalBurstFractureC1: false,
    CervicalBurstFractureC2: false,
    CervicalBurstFractureC3: false,
    CervicalBurstFractureC4: false,
    CervicalBurstFractureC5: false,
    CervicalBurstFractureC6: false,
    CervicalBurstFractureC7: false,
    CervicalBurstFractureT1: false,
    CervicalBurstFractureT2: false,
    
    // NEW: Chance Fracture
    CervicalChanceFracture: false,
    CervicalRetropulsion3: false,
    CervicalChanceFractureC1: false,
    CervicalChanceFractureC2: false,
    CervicalChanceFractureC3: false,
    CervicalChanceFractureC4: false,
    CervicalChanceFractureC5: false,
    CervicalChanceFractureC6: false,
    CervicalChanceFractureC7: false,
    CervicalChanceFractureT1: false,
    CervicalChanceFractureT2: false,
    
    // NEW: Flexion Tear Drop Fracture
    CervicalFlexionTearDropFracture: false,
    CervicalFlexionTearDropFractureC1: false,
    CervicalFlexionTearDropFractureC2: false,
    CervicalFlexionTearDropFractureC3: false,
    CervicalFlexionTearDropFractureC4: false,
    CervicalFlexionTearDropFractureC5: false,
    CervicalFlexionTearDropFractureC6: false,
    CervicalFlexionTearDropFractureC7: false,
    CervicalFlexionTearDropFractureT1: false,
    CervicalFlexionTearDropFractureT2: false,
    
    // NEW: Extension Tear Drop Fracture
    CervicalExtensionTearDropFracture: false,
    CervicalExtensionTearDropFractureC1: false,
    CervicalExtensionTearDropFractureC2: false,
    CervicalExtensionTearDropFractureC3: false,
    CervicalExtensionTearDropFractureC4: false,
    CervicalExtensionTearDropFractureC5: false,
    CervicalExtensionTearDropFractureC6: false,
    CervicalExtensionTearDropFractureC7: false,
    CervicalExtensionTearDropFractureT1: false,
    CervicalExtensionTearDropFractureT2: false,
    
    // NEW: Dens Fracture
    CervicalDonsFrature: false,
    CervicalDonsFratureType: '',
    
    // NEW: Spinous Process Fracture
    CervicalSpinousProcessFracture: false,
    CervicalSpinousProcessFractureC1: false,
    CervicalSpinousProcessFractureC2: false,
    CervicalSpinousProcessFractureC3: false,
    CervicalSpinousProcessFractureC4: false,
    CervicalSpinousProcessFractureC5: false,
    CervicalSpinousProcessFractureC6: false,
    CervicalSpinousProcessFractureC7: false,
    CervicalSpinousProcessFractureT1: false,
    CervicalSpinousProcessFractureT2: false,
    
    // Facet Joint Dislocation
    CervicalFacetJointDislocationFratureType: '',
    CervicalFacetJointDislocationFratureC1: false,
    CervicalFacetJointDislocationFratureC2: false,
    CervicalFacetJointDislocationFratureC3: false,
    CervicalFacetJointDislocationFratureC4: false,
    CervicalFacetJointDislocationFratureC5: false,
    CervicalFacetJointDislocationFratureC6: false,
    CervicalFacetJointDislocationFratureC7: false,
    CervicalFacetJointDislocationFratureT1: false,
    CervicalFacetJointDislocationFratureT2: false,
    
    // Collapse details
    CervicalCollapseC1: false,
    CervicalCollapseC2: false,
    CervicalCollapseC3: false,
    CervicalCollapseC4: false,
    CervicalCollapseC5: false,
    CervicalCollapseC6: false,
    CervicalCollapseC7: false,
    
    // Additional findings
    CervicalText: ''
  });

  useEffect(() => {
    const fetchDemographics = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const patientId = urlParams.get("id");
        if (!patientId) return;

        const response = await fetch(`${API_BASE_URL}/fetch-dicom/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ id: patientId }),
        });

        if (!response.ok) throw new Error(`Failed to fetch demographics (${response.status})`);
        const data = await response.json();
        console.log("✅ Fetched demographics:", data);

        const formattedStudyDate = data.study_date || "";
        const now = new Date();
        const formattedReportDate = formatToDDMMYYYY(now);
        const formattedReportTime = formatToHHMM(now);

        setFormData((prev) => ({
          ...prev,
          NameTextFR10: data.patient_name || "",
          IDTextFR10: data.patient_id || "",
          AgeTextFR10: data.age || "",
          GenderTextFR10: data.gender || "Male",
          TestDateTextFR10: formattedStudyDate,
          ReportDateTextFR10: formattedReportDate,
          ReferralDrTextFR10: data.referring_physician || "",
          ReporttimeTextFR10: formattedReportTime,
        }));
      } catch (error) {
        console.error("❌ Error fetching DICOM demographics:", error);
      }
    };
    fetchDemographics();
  }, []);

  function formatToHHMM(date) {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  function formatToDDMMYYYY(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const mapFormDataToReportFormat = () => {
    return formData;
  };

  const handleRadioChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleCheckboxChange = (field) => {
    setFormData(prev => ({ ...prev, [field]: !prev[field] }));
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleBack = () => {
    console.log('Back clicked');
    if (onClose) {
      onClose();
    }
  };

  const handleDone = () => {
    console.log('Form submitted:', formData);
    const reportData = mapFormDataToReportFormat();
    const report = generateXraySpineReport(reportData, currentUser);
    console.log('Generated Report:', report);
    
    if (generateReport) {
      generateReport(report);
    }
    
    console.log("✅ Report generated and sent to editor", report);
    alert('Form submitted successfully! Report generated in editor.');
    
    if (onClose) {
      onClose();
    }
  };

  const handleReject = () => {
    console.log('Form rejected');
    alert('Form rejected!');
    if (onClose) {
      onClose();
    }
  };

  const renderVertebraCheckboxes = (prefix, labels) => {
    return (
      <div className="grid grid-cols-2 gap-2 ml-4">
        {labels.map((label, index) => (
          <label key={index} className="flex items-center gap-2 cursor-pointer">
            <input 
              type="checkbox" 
              checked={formData[`${prefix}${label}`]} 
              onChange={() => handleCheckboxChange(`${prefix}${label}`)} 
              className="w-4 h-4 accent-pink-600" 
            />
            <span className="text-sm">{label}</span>
          </label>
        ))}
      </div>
    );
  };

  const renderDiscSpaceCheckboxes = (prefix, labels) => {
    return (
      <div className="grid grid-cols-2 gap-2 ml-4">
        {labels.map((label, index) => (
          <label key={index} className="flex items-center gap-2 cursor-pointer">
            <input 
              type="checkbox" 
              checked={formData[`${prefix}${label}`]} 
              onChange={() => handleCheckboxChange(`${prefix}${label}`)} 
              className="w-4 h-4 accent-pink-600" 
            />
            <span className="text-sm">{label.replace('C', 'C').replace('T', 'T')}</span>
          </label>
        ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg flex flex-col" style={{ maxHeight: '90vh' }}>
        {/* Header */}
        <div className="flex-shrink-0 flex items-center justify-between p-4 border-b">
          <h1 className="text-xl font-bold">X-RAY SPINE (CERVICAL)</h1>
          <div className="flex gap-2">
            <button onClick={handleBack} className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700">
              Back
            </button>
            <button onClick={handleDone} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
              Done
            </button>
            <button onClick={handleReject} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
              Reject
            </button>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {/* Patient Info */}
          <div className="grid grid-cols-5 gap-4 text-sm mb-6">
            <div>
              <label className="block text-gray-600 mb-1">Name</label>
              <input type="text" value={formData.NameTextFR10} onChange={(e) => setFormData(prev => ({ ...prev, NameTextFR10: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="Enter name" />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Patient ID</label>
              <input type="text" value={formData.IDTextFR10} onChange={(e) => setFormData(prev => ({ ...prev, IDTextFR10: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="Enter ID" />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Age</label>
              <input type="text" value={formData.AgeTextFR10} onChange={(e) => setFormData(prev => ({ ...prev, AgeTextFR10: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="Enter age" />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Test date</label>
              <input type="text" value={formData.TestDateTextFR10} onChange={(e) => setFormData(prev => ({ ...prev, TestDateTextFR10: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="DD-MM-YYYY" />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Report date</label>
              <input type="text" value={formData.ReportDateTextFR10} onChange={(e) => setFormData(prev => ({ ...prev, ReportDateTextFR10: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="DD-MM-YYYY" />
            </div>
          </div>

          {/* Gender */}
          <div className="mb-6">
            <div className="text-center text-gray-600 mb-2">Gender</div>
            <div className="flex justify-center gap-6">
              {['Male', 'Female', 'Others'].map(gender => (
                <label key={gender} className="flex items-center gap-2 cursor-pointer">
                  <input type="radio" checked={formData.GenderTextFR10 === gender} onChange={() => handleRadioChange('GenderTextFR10', gender)} className="w-4 h-4" />
                  <span>{gender}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Spine View */}
          <div className="mb-6">
            <div className="text-center text-gray-600 mb-2">Spine View</div>
            <div className="flex justify-center gap-6">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" checked={formData.SpineView === 'X-Ray View'} onChange={() => handleRadioChange('SpineView', 'X-Ray View')} className="w-4 h-4" />
                <span>X-Ray View</span>
              </label>
            </div>
            {formData.SpineView === 'X-Ray View' && (
              <div className="flex justify-center gap-6 mt-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.SpineViewAP} onChange={() => handleCheckboxChange('SpineViewAP')} className="w-4 h-4 accent-pink-600" />
                  <span>AP</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.SpineViewLateral} onChange={() => handleCheckboxChange('SpineViewLateral')} className="w-4 h-4 accent-pink-600" />
                  <span>LATERAL</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.SpineViewFlexion} onChange={() => handleCheckboxChange('SpineViewFlexion')} className="w-4 h-4 accent-pink-600" />
                  <span>FLEXION</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.SpineViewExtension} onChange={() => handleCheckboxChange('SpineViewExtension')} className="w-4 h-4 accent-pink-600" />
                  <span>EXTENSION</span>
                </label>
              </div>
            )}
          </div>

          {/* Main Conditions */}
          <div className="space-y-4 mb-6">
            {/* Normal Spine */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={formData.NormalSpine} onChange={() => handleCheckboxChange('NormalSpine')} className="w-5 h-5 accent-pink-600" />
              <span>Normal Spine Study?</span>
            </label>

            {/* Degenerative */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={formData.CervicalDegenerative} onChange={() => handleCheckboxChange('CervicalDegenerative')} className="w-5 h-5 accent-pink-600" />
              <span>Degenerative?</span>
            </label>

            {formData.CervicalDegenerative && (
              <div className="ml-8 space-y-4 border-l-2 border-gray-200 pl-6">
                {/* Lordosis */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.cervicalLordosis} onChange={() => handleCheckboxChange('cervicalLordosis')} className="w-4 h-4 accent-pink-600" />
                  <span>Lordosis?</span>
                </label>
                {formData.cervicalLordosis && (
                  <div className="ml-4 flex gap-6">
                    {['Maintained', 'Straightening', 'Exaggerated', 'Reversal'].map(type => (
                      <label key={type} className="flex items-center gap-2 cursor-pointer">
                        <input type="radio" checked={formData.cervicalLordosisType === type} onChange={() => handleRadioChange('cervicalLordosisType', type)} className="w-4 h-4" />
                        <span>{type}</span>
                      </label>
                    ))}
                  </div>
                )}

                {/* Osteophytes */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalOsteophytes} onChange={() => handleCheckboxChange('CervicalOsteophytes')} className="w-4 h-4 accent-pink-600" />
                  <span>Osteophytes?</span>
                </label>
                {formData.CervicalOsteophytes && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalOsteophytes', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7'])}
                  </div>
                )}

                {/* Endplate Sclerosis */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalEndplateSclerosis} onChange={() => handleCheckboxChange('CervicalEndplateSclerosis')} className="w-4 h-4 accent-pink-600" />
                  <span>Endplate Sclerosis?</span>
                </label>
                {formData.CervicalEndplateSclerosis && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalEndplateSclerosis', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7'])}
                  </div>
                )}

                {/* NEW: Vacuum Phenomenon */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalVacuumPhenomenon} onChange={() => handleCheckboxChange('CervicalVacuumPhenomenon')} className="w-4 h-4 accent-pink-600" />
                  <span>Vacuum Phenomenon?</span>
                </label>
                {formData.CervicalVacuumPhenomenon && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalVacuumPhenomenon', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7'])}
                  </div>
                )}

                {/* NEW: Schmorl's Nodes */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalSchmorlsNode} onChange={() => handleCheckboxChange('CervicalSchmorlsNode')} className="w-4 h-4 accent-pink-600" />
                  <span>Schmorl's nodes?</span>
                </label>
                {formData.CervicalSchmorlsNode && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalSchmorlsNode', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7'])}
                  </div>
                )}

                {/* NEW: Reduced Intervertebral Disc Space */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalInterVertebralDiscSpace} onChange={() => handleCheckboxChange('CervicalInterVertebralDiscSpace')} className="w-4 h-4 accent-pink-600" />
                  <span>Reduced Inter Vertebral disc space?</span>
                </label>
                {formData.CervicalInterVertebralDiscSpace && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected disc spaces:</div>
                    {renderDiscSpaceCheckboxes('CervicalInterVertebralDiscSpace', ['C1C2', 'C2C3', 'C3C4', 'C4C5', 'C5C6', 'C6C7'])}
                  </div>
                )}
              </div>
            )}

            {/* Fracture */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={formData.CervicalFracture} onChange={() => handleCheckboxChange('CervicalFracture')} className="w-5 h-5 accent-pink-600" />
              <span>Fracture?</span>
            </label>

            {formData.CervicalFracture && (
              <div className="ml-8 space-y-4 border-l-2 border-gray-200 pl-6">
                {/* Compression Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalCompressionFracture} onChange={() => handleCheckboxChange('CervicalCompressionFracture')} className="w-4 h-4 accent-pink-600" />
                  <span>Compression Fracture?</span>
                </label>
                {formData.CervicalCompressionFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalCompressionFracture', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'T1', 'T2'])}
                    <label className="flex items-center gap-2 cursor-pointer mt-2">
                      <input type="checkbox" checked={formData.CervicalRetropulsion1} onChange={() => handleCheckboxChange('CervicalRetropulsion1')} className="w-4 h-4 accent-pink-600" />
                      <span>Retropulsion?</span>
                    </label>
                  </div>
                )}

                {/* NEW: Burst Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalBurstFracture} onChange={() => handleCheckboxChange('CervicalBurstFracture')} className="w-4 h-4 accent-pink-600" />
                  <span>Burst Fracture?</span>
                </label>
                {formData.CervicalBurstFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalBurstFracture', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'T1', 'T2'])}
                    <label className="flex items-center gap-2 cursor-pointer mt-2">
                      <input type="checkbox" checked={formData.CervicalRetropulsion2} onChange={() => handleCheckboxChange('CervicalRetropulsion2')} className="w-4 h-4 accent-pink-600" />
                      <span>Retropulsion?</span>
                    </label>
                  </div>
                )}

                {/* NEW: Chance Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalChanceFracture} onChange={() => handleCheckboxChange('CervicalChanceFracture')} className="w-4 h-4 accent-pink-600" />
                  <span>Chance Fracture?</span>
                </label>
                {formData.CervicalChanceFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalChanceFracture', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'T1', 'T2'])}
                    <label className="flex items-center gap-2 cursor-pointer mt-2">
                      <input type="checkbox" checked={formData.CervicalRetropulsion3} onChange={() => handleCheckboxChange('CervicalRetropulsion3')} className="w-4 h-4 accent-pink-600" />
                      <span>Retropulsion?</span>
                    </label>
                  </div>
                )}

                {/* NEW: Flexion Tear Drop Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalFlexionTearDropFracture} onChange={() => handleCheckboxChange('CervicalFlexionTearDropFracture')} className="w-4 h-4 accent-pink-600" />
                  <span>Flexion Tear Drop fracture?</span>
                </label>
                {formData.CervicalFlexionTearDropFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalFlexionTearDropFracture', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'T1', 'T2'])}
                  </div>
                )}

                {/* NEW: Extension Tear Drop Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalExtensionTearDropFracture} onChange={() => handleCheckboxChange('CervicalExtensionTearDropFracture')} className="w-4 h-4 accent-pink-600" />
                  <span>Extension tear drop fracture?</span>
                </label>
                {formData.CervicalExtensionTearDropFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalExtensionTearDropFracture', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'T1', 'T2'])}
                  </div>
                )}

                {/* NEW: Dens Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalDonsFrature} onChange={() => handleCheckboxChange('CervicalDonsFrature')} className="w-4 h-4 accent-pink-600" />
                  <span>Dens Fracture?</span>
                </label>
                {formData.CervicalDonsFrature && (
                  <div className="ml-4 flex gap-6">
                    {['Type 1', 'Type 2', 'Type 3'].map(type => (
                      <label key={type} className="flex items-center gap-2 cursor-pointer">
                        <input type="radio" checked={formData.CervicalDonsFratureType === type} onChange={() => handleRadioChange('CervicalDonsFratureType', type)} className="w-4 h-4" />
                        <span>{type}</span>
                      </label>
                    ))}
                  </div>
                )}

                {/* NEW: Spinous Process Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={formData.CervicalSpinousProcessFracture} onChange={() => handleCheckboxChange('CervicalSpinousProcessFracture')} className="w-4 h-4 accent-pink-600" />
                  <span>Spinous Process fracture?</span>
                </label>
                {formData.CervicalSpinousProcessFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalSpinousProcessFracture', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'T1', 'T2'])}
                  </div>
                )}
              </div>
            )}

            {/* Facet Joint Dislocation */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={formData.CervicalFacetJointDislocationFrature} onChange={() => handleCheckboxChange('CervicalFacetJointDislocationFrature')} className="w-5 h-5 accent-pink-600" />
              <span>Facet Joint Dislocation?</span>
            </label>

            {formData.CervicalFacetJointDislocationFrature && (
              <div className="ml-8 space-y-4 border-l-2 border-gray-200 pl-6">
                <div className="flex gap-6">
                  {['Perched', 'Locked', 'Sublaxation'].map(type => (
                    <label key={type} className="flex items-center gap-2 cursor-pointer">
                      <input type="radio" checked={formData.CervicalFacetJointDislocationFratureType === type} onChange={() => handleRadioChange('CervicalFacetJointDislocationFratureType', type)} className="w-4 h-4" />
                      <span>{type}</span>
                    </label>
                  ))}
                </div>
                {formData.CervicalFacetJointDislocationFratureType && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalFacetJointDislocationFrature', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'T1', 'T2'])}
                  </div>
                )}
              </div>
            )}

            {/* Osteopenia */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={formData.CerivicalOsteopenia} onChange={() => handleCheckboxChange('CerivicalOsteopenia')} className="w-5 h-5 accent-pink-600" />
              <span>Osteopenia?</span>
            </label>

            {/* Collapse */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={formData.CervicalCollapse} onChange={() => handleCheckboxChange('CervicalCollapse')} className="w-5 h-5 accent-pink-600" />
              <span>Collapse?</span>
            </label>

            {formData.CervicalCollapse && (
              <div className="ml-8">
                <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                {renderVertebraCheckboxes('CervicalCollapse', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7'])}
              </div>
            )}

            {/* Additional Findings */}
            <div className="mt-6">
              <label className="block text-gray-600 mb-2">Additional Findings</label>
              <textarea value={formData.CervicalText} onChange={(e) => handleInputChange('CervicalText', e.target.value)} className="w-full px-3 py-2 border rounded" rows="3" placeholder="Enter any additional findings..." />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}